import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { HtmlParse } from 'utils'
import Tcenco from 'images/payments/cencosudscotibank.svg'
import MasterCard from 'images/payments/mastercad.svg'
import Visa from 'images/payments/visa.svg'
import AmericanExpress from 'images/payments/americanexpress.svg'
import Magna from 'images/payments/magna.svg'
import DinersClub from 'images/payments/dinersclub.svg'
import Redcompra from 'images/payments/redcompra.svg'
import { walletPaymentsName } from 'config/index'
import RadioButton from 'components/RadioButton'
import style from './style.scss' //NOSONAR

const PaymentMethodPrimeItem = (props) => {
    const {card, isChecked, callbackSelected, callbackSetCheckbox, unique} = props
    const callbackSelect = callbackSelected ? callbackSelected : () => {}
    const oneClick = walletPaymentsName.oneClick
    const catOneClick = walletPaymentsName.catOneClick
    const debitOneClick = walletPaymentsName.debitOneClick;
    const [check, setCheck] = useState(false)
    const [image, setImage] = useState(null)
    const [cardTitle, setCardTitle] = useState(null);

    useEffect(() => {
        setCheck(isChecked)
        if(isChecked){ 
            callbackSelected(card);
        }
    }, [isChecked])

    useEffect(() => {
        if (unique) {
            callbackSelect(card)
        }
    }, [unique])

    useEffect(() => {
        if (card?.paymentMethod === catOneClick) {
            setCardTitle('Tarjeta Cencosud Scotiabank');
            setImage(Tcenco)
        }

        if (card?.paymentMethod === debitOneClick) {
            setCardTitle('Tarjeta de débito');
            setImage(Redcompra)
        }
        
        if (card?.paymentMethod === oneClick) {
            setCardTitle('Tarjeta de crédito');
            switch (card.brand) {
                case 'MasterCard':
                    setImage(MasterCard)
                    break
                case 'Visa':
                    setImage(Visa)
                    break
                case 'AmericanExpress':
                    setImage(AmericanExpress)
                    break
                case 'Magna':
                    setImage(Magna)
                    break
                case 'DinersClub':
                    setImage(DinersClub)
                    break
            }
        }
    }, [card])

    const selectCard = () => {
        if (!check) {
            callbackSelect(card)
            callbackSetCheckbox(card.token)
        }
    }

    if (!card) return ''

    return (
        <section className="payment-method-prime-item" onClick={() => selectCard()}>
            <div className="payment-method-prime-checkbox">
                <RadioButton item={check} />
            </div>
            <div className="payment-method-prime-card-info">
                <div className="payment-method-prime-card-name">
                    {cardTitle}
                </div>
                <div className={`payment-method-prime-image ${card.brand === 'Visa' ? ' visa-card' : ''}`}>
                    <i>{HtmlParse(image)}</i>
                </div>
                <div className="payment-method-prime-number">**** {card.lastDigits}</div>
                <div className="payment-method-prime-label">{card.isFavorite ? 'Tarjeta predeterminada' : ''}</div>
            </div>
        </section>
    )
}

PaymentMethodPrimeItem.propTypes = {
    card: PropTypes.object,
    callbackSelected: PropTypes.func,
    callbackDelete: PropTypes.func,
    isChecked: PropTypes.bool,
    callbackSetCheckbox: PropTypes.func,
    unique: PropTypes.bool,
}

export default PaymentMethodPrimeItem
